import React, { useEffect, useState } from 'react';
import 'animate.css';

import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';

import * as S from './styles';
import { H4, TaglineP, TaglinePSpan } from '../../styles/stylesTypography';
import ProfileMenu from '../ProfileAccordion';
import maintainUtm from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";
import { useLocation } from 'react-router-dom';
import Notificacao from '../../assets/icons/icon-bell-gray.png';

import { isTotvs, isOmie } from '../../services/globalFunctions';
import ModalGenericV2 from "../modal/modalGenericV2";
import ButtonWithTextAndStatus from '../buttonWithTextAndStatus';
import TableSolicitacoesV2 from '../totvs/tableSolicitacao/indexV2';

import { store } from 'react-notifications-component';
import MenuHamburgerBlack from '../../assets/icons/icon-menu-hamburguer-black.svg';
import { useHeaderMenu } from '../../contexts/HeaderMenuContext';
import useMediaQuery from '../../hooks/useMediaQuery';

const HeaderV2 = ({ title, name, isMobile, showProfileProps, rightSlot = null, showMenuButton = true, titleFontSize }) => {
  const location = useLocation();
  // ≤760px: título vai sozinho pra 1ª linha (senão o pill de plano, que não
  // encolhe, espreme o título até sumir) - pill + período descem pra 2ª.
  const isCompactHeader = useMediaQuery('(max-width: 760px)');
  // Renderiza o hambúrguer aqui, na mesma linha do título/botão de plano,
  // em vez de deixar a Navbar desenhar o dela solta na tela.
  const { openMenu, setHasInlineMenuButton } = useHeaderMenu();
  useEffect(() => {
    setHasInlineMenuButton(true);
    return () => setHasInlineMenuButton(false);
  }, []);
  const [userPlanId, setUserPlanId] = useState(0);
  const [diasRestantes, setDiasRestantes] = useState(0);
  const [qtdNotification, setQtdNotification] = useState(
    () => parseInt(localStorage.getItem('@notif_count') ?? '0', 10) || 0
  );

  const updateQtdNotification = (value) => {
    setQtdNotification(value);
    localStorage.setItem('@notif_count', String(value));
  };
  // Respeita explicitamente showProfileProps quando fornecido; caso contrário, usa comportamento padrão
  const [showProfile, setShowProfile] = useState(
    showProfileProps === undefined ? true : showProfileProps
  );
  const [width, setWidth] = useState(window.innerWidth);
  const [gap, setGap] = useState(false);

  const userData = JSON.parse(localStorage.getItem("@userinfo"));
  const userFullName = userData?.name;
  const pathName = window.location.pathname;

  const [showButtonSynchronize, setShowButtonSynchronize] = useState(false)
  const [hasSynchronize, setHasSynchronize] = useState(false)

  const [loadingWebhookList, setLoadingWebhookList] = useState(false)
  const [WebhookList, setWebhookList] = useState([])

  const formatDateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('pt-BR', { timeZone: 'UTC' });
  };

  const handleReenviarWebhook = async (row) => {
    setLoadingWebhookList(true)
    const webhookId = row?.id;

    try {
      const response = await api.get(`/receitas/webhook/reenviar/${webhookId}`);
     
      if (response.status === 200) {
        store.addNotification({
          title: "Sucesso!",
          message: `Webhook reenviado com sucesso.`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true }
        });

        getReceitasWebhookListar()
      }

    } catch (error) {
      store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(
            error,
            "ERRO-572 Ocorreu um erro ao reenviar o webhook - Tente novamente, se o erro persistir acione o suporte."
          ),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true }
        });
    } finally {
      setLoadingWebhookList(false)
    }
  };

  const webhookColumns = [
    {
      key: 'numero_receita',
      label: 'Receita',
      minWidth: '90px',
      width: '90px',
      enableHorizontalScroll: true,
      render: (item) => <TaglineP fontWeight={600}>{item?.numero_receita ?? '-'}</TaglineP>
    },
    {
      key: 'integration_url',
      label: 'Webhook URL',
      minWidth: '280px',
      width: '340px',
      maxWidthContent: '340px',
      enableHorizontalScroll: true,
      render: (row) => <p style={{fontSize: '12px'}}>{row?.integration_url || '-'}</p>
    },
    {     
      key: 'modified',
      label: 'Última tentativa',
      minWidth: '180px',
      width: '100%',
      maxWidthContent: '100%',
      render: (row) => <TaglineP fontWeight={600}>{formatDateTime(row?.modified)}</TaglineP>
    },
    {
      key: 'actions',
      label: 'Reenviar',
      minWidth: '120px',
      width: '100%',
      render: (row) => ( <ButtonWithTextAndStatus status={3} text="Enviar" onClick={() => handleReenviarWebhook(row)} />)
    }
  ];

  useEffect(() => {
    if (userData?.contrato) {
      setUserPlanId(userData.contrato.agro_plan_config.agro_plan_id);
      setDiasRestantes(userData.contrato.dias_restantes);
    }
  }, []);

  useEffect(() => {
    if (!isTotvs()) {
      const fetchNotifications = async () => {
        try {
          if (!showProfile) {
            setQtdNotification(0);
            return;
          }
          const response = await api.get(`/notificacoes/quantidade`);
          updateQtdNotification(response.data.data);
        } catch (error) {
          console.error("Erro ao buscar notificações.");
        }
      };
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      setWidth(currentWidth);
      // Apenas altera showProfile pela largura quando a prop não foi fornecida
      if (showProfileProps === undefined) {
        setShowProfile(currentWidth > 767);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [showProfileProps]);

  // Mantém showProfile sincronizado caso a prop mude dinamicamente
  useEffect(() => {
    if (showProfileProps !== undefined) {
      setShowProfile(showProfileProps);
    }
  }, [showProfileProps]);

  const validarModelo = (regex, str) => regex.test(str);

  const ShowTitle = () => {
    if (title && title.length > 0) {
      if (validarModelo(/^\/fazendas\/\d+\/\d+$/, pathName)) {
        return <S.UserName titleFontSize={titleFontSize}><H4>{name}</H4></S.UserName>;
      } else {
        return <S.UserName titleFontSize={titleFontSize}><H4>{title}</H4></S.UserName>;
      }
    } else {
      return <S.UserName titleFontSize={titleFontSize}><H4>Olá, {userFullName}</H4></S.UserName>;
    }
  };

  const [syncingOmie, setSyncingOmie] = React.useState(false);

  const sincronizarOmie = async () => {
    if (syncingOmie) return;
    setSyncingOmie(true);
    try {
      const response = await api.get(`/omie/sincronizar`);
      const { jaEmAndamento } = response.data;
      store.addNotification({
        title: "Sincronização Omie",
        message: jaEmAndamento
          ? "Já existe uma sincronização em andamento - aguarde terminar (você será avisado pelo sininho) antes de iniciar outra."
          : "Sincronização de pedidos iniciada em segundo plano - você será avisado pelo sininho quando terminar.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000, onScreen: true }
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-580 Ocorreu um erro ao sincronizar pedidos Omie - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setSyncingOmie(false);
    }
  }

  // Botão "Sincronizar Dados" (só Home) - pedidos + varredura ampla de clientes/fazendas.
  const [syncingOmieDados, setSyncingOmieDados] = React.useState(false);

  // Sync de produtores/fazendas roda em background no servidor (pode levar minutos numa
  // conta com muitos clientes na Omie). Sem polling: quando terminar, o back dispara uma
  // notificação de verdade (sininho, agro_notifications) pro usuário - reaproveita o
  // mecanismo que já existe em vez de ficar checando status em loop.
  const sincronizarDadosOmie = async () => {
    if (syncingOmieDados) return;
    setSyncingOmieDados(true);
    try {
      const response = await api.get(`/omie/sincronizar/dados`);
      const { jaEmAndamento } = response.data;
      store.addNotification({
        title: "Sincronização Omie",
        message: jaEmAndamento
          ? "Já existe uma sincronização em andamento - aguarde terminar (você será avisado pelo sininho) antes de iniciar outra."
          : "Sincronização iniciada em segundo plano - pedidos e produtores/fazendas estão sendo atualizados. Pode levar alguns minutos, você será avisado pelo sininho a cada etapa concluída.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 6000, onScreen: true }
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-581 Ocorreu um erro ao sincronizar dados Omie - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setSyncingOmieDados(false);
    }
  }

  // Botão "Sincronizar Produtores" (só tela de Produtores) - produtores + fazendas relacionadas.
  const [syncingOmieProdutores, setSyncingOmieProdutores] = React.useState(false);
  const sincronizarProdutoresOmie = async () => {
    if (syncingOmieProdutores) return;
    setSyncingOmieProdutores(true);
    try {
      const response = await api.get(`/omie/sincronizar/produtores`);
      const { produtoresCriados, fazendasCriadas } = response.data;
      store.addNotification({
        title: "Sincronização Omie",
        message: `${produtoresCriados} produtor(es) e ${fazendasCriadas} fazenda(s) sincronizados.`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 3000, onScreen: true }
      });
      setTimeout(() => window.location.reload(), 3000);
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-582 Ocorreu um erro ao sincronizar produtores Omie - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setSyncingOmieProdutores(false);
    }
  }

  const getReceitasWebhookPendentes = async () => {
    try {
      const response = await api.get(`/receitas/webhook/pendencias`);

      if (response.data.pendencias === true) {
        setShowButtonSynchronize(true)
      }
    } catch (error) {
      setShowButtonSynchronize(false)

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-573 Ocorreu um erro ao verificar pendencias - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    }
  }

  const getReceitasWebhookListar = async () => {
    setLoadingWebhookList(true)
    try {
      const response = await api.get(`/receitas/webhook/listar`);

      if (response.status === 200) {
        if (response.data.length > 0) {
          setWebhookList(response.data)
        } else {
           setHasSynchronize(false)
           setShowButtonSynchronize(false)
        }
      }
    } catch (error) {
      setShowButtonSynchronize(false)

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-574 Ocorreu um erro ao verificar pendencias - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setLoadingWebhookList(false)
    }
  }

  useEffect(() => {
    const path = location.pathname;
    if (path === "/checkout" || path.startsWith("/checkout/") || path.startsWith("/simulacaoplano")) {
      return;
    }else{
      getReceitasWebhookPendentes();
    }
  }, [location.pathname]);

  const getPlanName = userData?.contrato?.agro_plan_config?.nome_plano;

  const buttonPlansChange = () => {
    const currentPageId = getCurrentPageIdWithDevice();

    switch (getPlanName) {
      case "PLANO PRO":
      case "PLANO LIGHT":
      case "PLANO BASIC":
        return (
          <a href={`/gerenciar-plano${maintainUtm(`${currentPageId}-headergerenciarplano`)}`}>
            <S.ManagePlansButton>
              <TaglinePSpan>GERENCIAR PLANO</TaglinePSpan>
            </S.ManagePlansButton>
          </a>
        );
      case "PLANO PRÉ-PAGO":
        return (
          <a href={`/comprar_receitas${maintainUtm(`${currentPageId}-headercomprarcreditos`)}`}>
            <S.SubscribeButton>
              <TaglinePSpan>COMPRAR CRÉDITOS</TaglinePSpan>
            </S.SubscribeButton>
          </a>
        );
      case "TESTE GRÁTIS":
        return (
          <a href={`/planos${maintainUtm(`${currentPageId}-headerassinaragora`)}`}>
            <S.SubscribeButton>
              <TaglinePSpan>ASSINAR AGORA</TaglinePSpan>
            </S.SubscribeButton>
          </a>
        );
      case "PLANO PROTHEUS":
        return userData?.agro_permission_id !== 4 ? (
          showButtonSynchronize && (
          <ButtonWithTextAndStatus status={3} text="Sincronizar dados" onClick={() => {setHasSynchronize(true); getReceitasWebhookListar()}} />
          )
        ) : null;
      case "PLANO OMIE":
        return userData?.agro_permission_id !== 4 ? (
          location.pathname === "/" ? (
            <ButtonWithTextAndStatus status={3} text="Sincronizar dados" onClick={sincronizarDadosOmie} loading={syncingOmieDados} disabled={syncingOmieDados} />
          ) : location.pathname === "/produtores" ? (
            <ButtonWithTextAndStatus status={3} text="Sincronizar produtores" onClick={sincronizarProdutoresOmie} loading={syncingOmieProdutores} disabled={syncingOmieProdutores} />
          ) : (
            <ButtonWithTextAndStatus status={3} text="Sincronizar pedidos" onClick={sincronizarOmie} loading={syncingOmie} disabled={syncingOmie} />
          )
        ) : (
          <a href={`/gerenciar-plano${maintainUtm(`${currentPageId}-headergerenciarplano`)}`}>
            <S.ManagePlansButton>
              <TaglinePSpan>GERENCIAR PLANO</TaglinePSpan>
            </S.ManagePlansButton>
          </a>
        );
      default:
        return null;
    }
  };

  const getGap = () => {
    if (getPlanName === "PLANO PRO") {
      return false;
    } else if (getPlanName === "PLANO BASIC" || getPlanName === "PLANO LIGHT" || getPlanName === "TESTE GRÁTIS") {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    setGap(getGap());
  }, [getPlanName]);

  const titleGroup = (
    <S.TitleGroup>
      {showMenuButton && (
        <S.MobileMenuButton onClick={(e) => { e.stopPropagation(); openMenu(); }}>
          <img src={MenuHamburgerBlack} alt="menu" />
        </S.MobileMenuButton>
      )}
      {ShowTitle()}
    </S.TitleGroup>
  );

  // showProfile fica false por padrão em telas ≤767px (ver handleResize) -
  // antes disso o <S.BellProfileGroup> ainda era renderizado vazio (sino e
  // perfil escondidos por dentro), deixando uma div sem conteúdo no DOM em
  // qualquer tela que não force showProfileProps. Agora o grupo inteiro só
  // existe quando tem algo pra mostrar.
  const bellProfileGroup = showProfile && (
    <S.BellProfileGroup>
      <S.ContainerNotification hasNotification={width > 760 && qtdNotification > 0}>
        {width > 760 && !isTotvs() &&(
          <a href="/notificacao">
            <img src={Notificacao} alt="Ícone de notificação" />
            {qtdNotification > 0 && (
              <S.NotifCountBadge>
                {qtdNotification > 9 ? '9+' : qtdNotification}
              </S.NotifCountBadge>
            )}
          </a>
        )}
      </S.ContainerNotification>

      <ProfileMenu
        userData={userData}
        planId={userPlanId}
        diasRestantes={diasRestantes}
        isMobile={isMobile}
      />
    </S.BellProfileGroup>
  );

  return (
    <>
    <S.Container id="header">
      {isCompactHeader ? (
        // ≤760px: ☰ + título + pill de plano na 1ª linha; seletor de
        // período (rightSlot) sozinho na 2ª linha.
        <S.MobileHeaderStack hasPeriodSelector={!!rightSlot}>
          <S.MobileSecondaryRow>
            {titleGroup}
            {buttonPlansChange()}
          </S.MobileSecondaryRow>
          {rightSlot && (
            <S.PeriodSelectorSlot>{rightSlot}</S.PeriodSelectorSlot>
          )}
          {bellProfileGroup}
        </S.MobileHeaderStack>
      ) : (
        <>
          <S.ContainerSubscribeAndUser gap={gap} alignLeft={!showMenuButton}>
            {buttonPlansChange()}
            {titleGroup}
          </S.ContainerSubscribeAndUser>

          {(rightSlot || bellProfileGroup) && (
            <S.ContainerNotificationAndProfile>
              {rightSlot && (
                <S.PeriodSelectorSlot>{rightSlot}</S.PeriodSelectorSlot>
              )}
              {bellProfileGroup}
            </S.ContainerNotificationAndProfile>
          )}
        </>
      )}
    </S.Container>

    {hasSynchronize && (
      <ModalGenericV2 
      show={hasSynchronize} 
      onHide={() => setHasSynchronize(false)}
      marginBottom="0"
      >
        <S.ContainerModal>
          {loadingWebhookList ? (
          <S.LoadingContainer>
            <S.Loading />
          </S.LoadingContainer> 
          ):(
            <TableSolicitacoesV2
              columns={webhookColumns}
              data={WebhookList}
              showAll
              itemsPerPage={WebhookList.length || 16}
              serverSide
              getRowId={(item, idx) => item?.id || idx}
              onRowClick={() => null}
              isRowDisabled={() => true}
            />
          )}
        </S.ContainerModal>
      </ModalGenericV2>
    )}
  </>
  );
};

export default HeaderV2;
